import Suggestions from './Suggestions';
export { Suggestions as default };
